// src/components/Topbar.js
import React from "react";
import logo from "../../assets/img/logo.webp";

function Topbar() {
  return (
    <div className="container-fluid d-none d-lg-block">
      <div className="row align-items-center py-4 px-xl-1">
        <div className="col-lg-3">
          <a href="/" className="text-decoration-none">
            <h1 className="m-0">
              <span className="text-primary">DIS</span>SEMP
            </h1>
            <h3 className="m-0">ACADEMY COURSES</h3>
          </a>
        </div>
        <div className="col-lg-2 text-right">
          <div className="d-inline-flex align-items-center">
            <i className="fas fa-2x fa-map-marker-alt text-primary mr-3"></i>
            <div className="text-left">
              <h6 className="font-weight-semi-bold mb-1">Ubicación</h6>
              <small>Oficina administrativa Medellín, COLOMBIA</small>
            </div>
          </div>
        </div>
        <div className="col-lg-2 text-right">
          <div className="d-inline-flex align-items-center">
            <i className="fa fa-2x fa-envelope text-primary mr-3"></i>
            <div className="text-left">
              <h6 className="font-weight-semi-bold mb-1">Email</h6>
              <small>info@dissempacademy.com</small>
            </div>
          </div>
        </div>
        <div className="col-lg-2 text-right">
          <div className="d-inline-flex align-items-center">
            <i className="fa fa-2x fa-phone text-primary mr-3"></i>
            <div className="text-left">
              <h6 className="font-weight-semi-bold mb-1">Contacto</h6>
              <a href="https://api.whatsapp.com/send?phone=573014953565">
                <small>+57 301 4953565</small>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-2 text-right">
          <div className="d-inline-flex align-items-center">
            <div className="text-left">
              <img className="img-logo" src={logo} alt="Logo" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Topbar;
